const infoManual = `年度の掛金納付対象職員届の提出が完了しました。`;
const infoManualTwo = `　次の「振込依頼書ダウンロード」ボタンを押して、振込依頼書をダウンロードし、５月末日までに掛金を納付してください。<
　なお、この振込依頼書に依らず、インターネットバンキング等を利用して掛金を振り込む場合は、振込依頼名の前に６桁の共済契約者番号を入力し、続けて共済契約名を入力してください（例示：139999 ●●ﾌｸｼｶｲ）。`;

export { infoManual, infoManualTwo };
